import React from 'react';
import { connect } from 'react-redux';
import { Grid } from '@mui/material';
import { getOrgsBuildings } from '../../redux/selectors/buildings';
import { getEquipmentForBuilding } from '../../redux/selectors/equipment';
import Collapsible from '../util/Collapsible';
import BuildingBrokenPoints from './BuildingBrokenPoints';
import BuildingIngestGraph from './BuildingIngestGraph';
import BuildingStalePoints from './BuildingStalePoints';

const BuildingQa = ({ buildings, latestTimestamps, equipByBuilding }) => (
  <Grid container spacing={8}>
    {buildings.map((b) => {
      const equip = equipByBuilding[b.id] || [];
      const hasIngest = !!latestTimestamps[b.id];
      return hasIngest ? (
        <Grid item xs={10} key={b.id}>
          <Collapsible headerContent={b.name}>
            <BuildingIngestGraph building={b} />
            <BuildingBrokenPoints building={b} equipment={equip} />
            <BuildingStalePoints building={b} equipment={equip} />
          </Collapsible>
        </Grid>
      ) : null;
    })}
  </Grid>
);

export default connect((state, { org }) => {
  const {
    entities: {
      ingestStats: { latestTimestamps },
    },
  } = state;
  const buildings = getOrgsBuildings(state, org);
  const equipByBuilding = buildings.reduce((obj, b) => {
    // eslint-disable-next-line no-param-reassign
    obj[b.id] = getEquipmentForBuilding(state, b.id);
    return obj;
  }, {});
  return { buildings, equipByBuilding, latestTimestamps };
})(BuildingQa);
